<template>
    <div class="web-tab-page">
        <v-tip
            ref="createTip1"
            :offset="20"
            kind="large"
            clazz="rule-list-createTip"
        >
            <div style="width:390px;">
                <h3>支持多套窗口形象模板并应用到各个接待组件，实现企业个性化管理多品牌的访客端样式和节假日定制化的场景诉求。</h3>
                <div>1/2</div>
            </div>
            <div class="rule-list-createTip-footer">
                <v-button @click="createNextTip">
                    下一步
                </v-button>
            </div>
        </v-tip>
        <v-tip
            ref="createTip2"
            kind="large"
            clazz="rule-list-createTip"
        >
            <div style="width:390px;">
                <h3>历史一套配置内容已合并到默认模板，应用于当前所有的网页接入和小程序插件接待组件。</h3>
                <div>2/2</div>
            </div>
            <div class="rule-list-createTip-footer">
                <v-button
                    @click="createPrevTip"
                    class="prevStep"
                >
                    上一步
                </v-button>
                <v-button @click="closeTip">
                    关闭
                </v-button>
            </div>
        </v-tip>
        <v-tip
            ref="useDetailRef"
            placement="top"
            kind="small"
        >
            <div class="use-detail-tip">
                <template v-if="!hasMigrated">
                    <template v-for="type in SHOW_USE_DETAIL_ORDER">
                        <div
                            :key="type"
                            v-if="formatUseDetailMap(rowUseDetail)[type].length"
                            class="detail-line"
                        >
                            <span class="label">{{ USE_DETAIL_TYPE_LABEL[type] }}</span>
                            <span class="value">{{
                                formatUseDetailMap(rowUseDetail)[type]
                                    .map(detail => detail.wpaName).join('，')
                            }}</span>
                        </div>
                    </template>
                </template>
                <span v-else class="value">{{
                    getUseDetails(rowUseDetail)
                        .map(detail => detail.wpaName).join('，')
                }}</span>
            </div>
        </v-tip>
        <lamp-tip local-key="chatWindowWebTabDetailLampTip">
            <div class="lamptip-desc">
                <p v-if="channelType === 1">支持多套窗口形象配置，历史内容已合并至默认模板，适用于所有小程序插件接待组件。</p>
                <p v-else-if="!hasMigrated">网页会话现支持多套窗口形象配置。历史内容已合并至默认模板，适用于所有网页和小程序插件接待组件。</p>
                <p v-else>支持多套窗口形象配置，历史内容已合并至默认模板，适用于所有网页接待组件。</p>
                <p>新建的接待组件自动应用默认模板，如需个性化样式，可创建窗口形象模板并选择应用的位置，以满足企业多品牌管理及节假日定制需求。</p>
            </div>
        </lamp-tip>
        <div class="operate-container">
            <v-tip
                ref="addLimitTipRef"
                :disabled="!reachLimit"
                placement="top"
                kind="small"
            >
                <div :style="{ padding: '8px' }">
                    最多可以新建 50 个窗口形象配置
                </div>
            </v-tip>
            <div
                v-tip:addLimitTipRef.hover
                style="width: fit-content"
            >
                <v-button
                    @click="onCreate"
                    :disabled="reachLimit"
                    class="create-btn"
                    status="primary"
                >
                    <v-icon name="new" />
                    <span
                        v-if="showGuideTips"
                        v-tip:createTip1.show
                    >新建</span>
                    <span v-else>新建</span>
                </v-button>
            </div>
        </div>
        <v-table
            :data="records"
            :loading="loading"
            class="records-table"
        >
            <v-table-column
                key="windowTemplateName"
                label="模版名称"
            >
                <template
                    slot="cell"
                    slot-scope="{ row }"
                >
                    <div class="tpl-name-col">
                        <span>{{ row.windowTemplateName }}</span>
                        <span
                            v-if="!row.isNew && showGuideTips"
                            v-tip:createTip2.show
                            class="tag"
                        >默认</span>
                        <span
                            v-else-if="!row.isNew"
                            class="tag"
                        >默认</span>
                    </div>
                </template>
            </v-table-column>
            <v-table-column
                key="themeColor"
                label="会话窗口颜色"
            >
                <template
                    slot="cell"
                    slot-scope="{ row }"
                >
                    <div
                        :style="{ background: row.themeColor }"
                        class="theme-color-col"
                    />
                </template>
            </v-table-column>
            <v-table-column
                key="lastUpdateTime"
                label="最近修改时间"
            >
                <template
                    slot="cell"
                    slot-scope="{ row }"
                >
                    <span>{{ formatUpdateTime(row.lastUpdateTime) }}</span>
                </template>
            </v-table-column>
            <v-table-column
                key="useDetail"
                label="应用位置"
            >
                <template
                    slot="cell"
                    slot-scope="{ row }"
                >
                    <div class="use-detail-col" @mouseenter="handleMouseenter(row.useDetail)">
                        <span v-if="!row.isNew">所有未单独设置窗口形象的接待组件</span>
                        <span v-else-if="!hasMigrated && !row.useDetail.length">-</span>
                        <span v-else-if="hasMigrated && !getUseDetails(row.useDetail).length">-</span>
                        <div v-else>
                            <span
                                v-html="breviaryUseDetailHtml(row.useDetail)"
                                class="detail-label"
                            />
                            <template v-if="!hasMigrated">
                                <span
                                    v-if="row.useDetail.length > this.BREVIARY_COUNT"
                                    v-tip:useDetailRef.hover
                                    class="show-detail-tip"
                                >等{{ row.useDetail.length }}个</span>
                            </template>
                            <template v-else>
                                <span
                                    v-if="getUseDetails(row.useDetail).length > this.BREVIARY_COUNT"
                                    v-tip:useDetailRef.hover
                                    class="show-detail-tip"
                                >等{{ getUseDetails(row.useDetail).length }}个</span>
                            </template>
                        </div>
                    </div>
                </template>
            </v-table-column>
            <v-table-column
                key="operate"
                align="right"
            >
                <template
                    slot="cell"
                    slot-scope="{ row }"
                >
                    <template>
                        <span
                            @click="onEdit(row)"
                            class="btn"
                        >编辑</span>
                    </template>
                    <template v-if="row.isNew">
                        <span
                            v-popconfirm:deleteConfirmRef
                            class="btn"
                            @click.stop="() => deleteId = row.id"
                        >删除</span>
                    </template>
                    <template v-else>
                        <v-tip
                            ref="defaultTplTipRef"
                            placement="top"
                            kind="small"
                        >
                            <span class="default-tpl-tip">默认模板，无法删除</span>
                        </v-tip>
                        <span
                            v-tip:defaultTplTipRef.hover
                            class="btn disable"
                        >删除</span>
                    </template>
                </template>
            </v-table-column>
        </v-table>
        <v-pagination
            :key="channelType"
            @change="onPaginationChange"
            v-bind="pagination"
            class="records-pagination"
        />
        <v-popconfirm
            ref="deleteConfirmRef"
            @confirm="onDelete()"
            placement="bottom-end"
            status="warning"
        >
            <h3 class="delete-confirm-header">
                确定要删除吗？
            </h3>
            <div class="delete-confirm-body">
                删除该模板后，当前已应用的接待组件将恢复使用默认模板。
            </div>
            <span slot="confirm-text">删除</span>
        </v-popconfirm>
    </div>
</template>

<script>
import { Icon } from 'vhtml-ui';
import moment from 'moment';
import LampTip from 'src/components/lamp-tip';

const sprites = require.context('@/assets/icons', true, /[^.]+\.svg$/);
Icon.addSprites(sprites);

const DEFAULT_PAGINATION = {
    index: 1,
    count: 15,
    total: 0,
};

export const USE_DETAIL_TYPE = {
    WEBIM: 4, // 网页
    MINI_PROGRAM_PLUGIN: 54, // 小程序插件
};

export const USE_DETAIL_TYPE_LABEL = {
    [USE_DETAIL_TYPE.WEBIM]: '网页',
    [USE_DETAIL_TYPE.MINI_PROGRAM_PLUGIN]: '小程序插件',
};

// 应用位置显示顺序
export const SHOW_USE_DETAIL_ORDER = [
    USE_DETAIL_TYPE.WEBIM,
    USE_DETAIL_TYPE.MINI_PROGRAM_PLUGIN,
];

const CREATE_LIMIT = 50;

const GUIDE_TIP_KEY = 'chatWindowWebTabDetailGuideTip';
const GUIDE_DOWNLINE_DATE = '2024-01-01';

/**
 * 将使用的wpa列表按照类型分好类
 * @params useDetail: Array<{ type: string, wpaId: number, wpaName: string }>
 * @returns {{ [detailType: number]: Array<{ type: string, wpaId: number, wpaName: string }> }}
 */
export const formatUseDetailMap = (useDetail = []) => {
    const map = {
        [USE_DETAIL_TYPE.WEBIM]: [],
        [USE_DETAIL_TYPE.MINI_PROGRAM_PLUGIN]: [],
    };

    useDetail.forEach((detail) => {
        map[detail.type].push(detail);
    });
    return map;
};

export default {
    name: 'Index',
    components: {
        LampTip,
    },
    props: {
        isShowQQKfuin: {
            type: Boolean,
            default: true,
        },
        isShowQQKfext: {
            type: Boolean,
            default: true,
        },
        channelIds: {
            type: Array,
            default: () => [],
        },
        channelType: {
            type: Number,
            default: 0,
        },
        hasMigrated: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            loading: false,
            records: [],
            pagination: { ...DEFAULT_PAGINATION },
            showGuideTips: false,

            USE_DETAIL_TYPE: Object.freeze(USE_DETAIL_TYPE),
            USE_DETAIL_TYPE_LABEL: Object.freeze(USE_DETAIL_TYPE_LABEL),
            SHOW_USE_DETAIL_ORDER: Object.freeze(SHOW_USE_DETAIL_ORDER),
            BREVIARY_COUNT: 3, // 应用位置缩略文字显示个数
            deleteId: 0, // 点击删除的模版id
            rowUseDetail: [],
        };
    },
    computed: {
        reachLimit() {
            return this.pagination.total >= CREATE_LIMIT;
        },
    },
    watch: {
        channelType() {
            this.initData();
        }
    },
    created() {
        this.initData();
    },
    methods: {
        initData() {
            this.loading = true;
            this.fetchCurPageWebWindowRecords(this.pagination.index, this.pagination.count)
                .finally(() => {
                    this.loading = false;
                    this.checkGuideTip();
                });
        },
        fetchCurPageWebWindowRecords(index, count) {
            const params = {
                index,
                count,
                channelType: this.channelType === 1 ? 54 : 4,
            };

            return this.$ajax
                .gatewayGet('/v1/kf/receptionConf/listWebWindowStyle', { params })
                .then(({ code, message, data }) => {
                    const SUCCESS_CODE = 0;
                    if (code !== SUCCESS_CODE) {
                        throw new Error(message || '发生错误，请刷新重试');
                    }
                    this.records = data.records;
                    this.pagination.total = data.total;
                })
                .catch((err) => {
                    this.$message.error(err.message);
                    throw err;
                });
        },
        onPaginationChange(index, count) {
            this.loading = true;
            this.pagination.index = index;
            this.pagination.count = count;
            this.fetchCurPageWebWindowRecords(index, count)
                .finally(() => (this.loading = false));
        },
        onCreate() {
            const params = {
                tplId: 0, // 新建跳过去该参数为0
                isDefaultTpl: Number(false), // // url上面携带的布尔值还是转化为数字表示
                channelType: this.channelType,
            };

            this.$router.push({
                name: 'WebTabDetail',
                params,
            });
        },
        onEdit({ id: tplId, isNew }) {
            const params = {
                tplId,
                isDefaultTpl: Number(!isNew), // url上面携带的布尔值还是转化为数字表示
                channelType: this.channelType,
            };

            this.$router.push({
                name: 'WebTabDetail',
                params,
            });
        },
        deleteRecordReq(id) {
            return this.$ajax
                .gatewayPost('/v1/kf/receptionConf/deleteWebWindowStyle', { id })
                .then(({ code, message }) => {
                    const SUCCESS_CODE = 0;
                    if (code !== SUCCESS_CODE) {
                        throw new Error(message || '发生错误，请刷新重试');
                    }
                    this.$message.success('删除成功');
                })
                .catch((err) => {
                    this.$message.error(err.message);
                    throw err;
                });
        },
        onDelete() {
            this.loading = true;
            this.deleteRecordReq(this.deleteId)
                .then(() => {
                    // 删除某一行以后回到第一页数据
                    this.pagination = { ...DEFAULT_PAGINATION };
                    return this.fetchCurPageWebWindowRecords(this.pagination.index, this.pagination.count);
                })
                .finally(() => (this.loading = false));
        },
        formatUpdateTime(timestamp) {
            // timestamp单位s
            return moment(timestamp * 1000).format('YYYY-MM-DD');
        },
        formatUseDetailMap,
        breviaryUseDetailHtml(useDetail) {
            let html = [];
            if(!this.hasMigrated) {
                const map = this.formatUseDetailMap(useDetail);
                let breviaryCount = this.BREVIARY_COUNT;
                for (let i = 0; i < this.SHOW_USE_DETAIL_ORDER.length; i++) {
                    const orderType = this.SHOW_USE_DETAIL_ORDER[i];
                    const details = map[orderType];

                    if (details.length) {
                        html.push(`<span class="desc">${this.USE_DETAIL_TYPE_LABEL[orderType]}：</span>`);

                        // 尝试获取breviaryCount个详情项
                        const tryGetDetails = details.slice(0, breviaryCount);
                        // 剩余详情项
                        breviaryCount -= tryGetDetails.length;

                        const text = tryGetDetails.map(detail => detail.wpaName).join('，');
                        html.push(`<span class="value">${text}</span>`);
                    }

                    // 每种类型文本后面加个空格间隔
                    html.push(' ');

                    // 如果已经获取到breviaryCount个详情项，就不再继续获取
                    if (breviaryCount <= 0) {
                        break;
                    }
                }
            } else {
                const details = this.getUseDetails(useDetail);
                if (details.length) {
                    const tryGetDetails = details.slice(0, this.BREVIARY_COUNT);
                    const text = tryGetDetails.map(detail => detail.wpaName).join('，');
                    html.push(`<span class="value">${text}</span>`);
                }
            }
            return html.join('');
        },
        getUseDetails(useDetail) {
            const map = this.formatUseDetailMap(useDetail);
            const orderType = this.channelType === 1 ? this.USE_DETAIL_TYPE.MINI_PROGRAM_PLUGIN : this.USE_DETAIL_TYPE.WEBIM;
            return map[orderType];
        },
        checkGuideTip() {
            // 检测localStorage中是否已经有了该key
            const guideTip = localStorage.getItem(GUIDE_TIP_KEY);
            if (guideTip) {
                return;
            }

            // 检测当前时间是否大于下线时间
            const now = moment();
            const downLineDate = moment(GUIDE_DOWNLINE_DATE);
            if (now.isAfter(downLineDate)) {
                return;
            }

            // 显示引导tip
            this.showGuideTips = true;
            this.$nextTick(() => {
                this.$refs.createTip1.show();
                this.$refs.createTip2.hide();
            });
            localStorage.setItem(GUIDE_TIP_KEY, '1');
        },
        createNextTip() {
            this.$refs.createTip1.hide();
            this.$refs.createTip2.show();
        },
        createPrevTip() {
            this.$refs.createTip1.show();
            this.$refs.createTip2.hide();
        },
        closeTip() {
            this.$refs.createTip1.hide();
            this.$refs.createTip2.hide();
        },
        handleMouseenter(value) {
            this.rowUseDetail = value;
        },
    },
};
</script>

<style lang="less">
.rule-list-createTip {
    background: var(--color-green-5, #0fb87f);
    color: #fff;
    .v-popper__arrow:before,
    .v-popper__arrow:after{
        border-color: var(--color-green-5, #0fb87f);
    }
    &-footer {
        display: flex;
        justify-content: flex-end;
        .v-button {
            color: var(--color-success-normal, #0fb87f);
            margin-left: 10px;
            &:hover{
                background: #fff
            }
        }
        .v-button.prevStep {
            background: transparent;
            color: var(--white, #fff);
            border: 1px solid #FFFFFF;
            &:hover{
                background: transparent
            }
        }
    }
}
</style>
<style lang="less" scoped>
.use-detail-tip {
    padding: 8px 10px;
    max-width: 400px;
    .detail-line {
        width: 400px;
        display: flex;
        margin-top: 12px;

        &:first-child {
            margin-top: 0;
        }

        .label {
            flex: 0 0 80px;
            color: var(--text-color-text-secondary, rgba(1, 10, 40, 0.65));
            font-family: PingFang SC;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 20px; /* 142.857% */
        }
    }
    .value {
        color: var(--text-color-text-primary, rgba(0, 1, 11, 0.93));
        font-family: PingFang SC;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 142.857% */
    }
}

.default-tpl-tip {
    padding: 8px 10px;
    color: #333;
    font-family: PingFang SC;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.delete-confirm-header {
    color: rgba(30, 35, 48, 1);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.delete-confirm-body {
    width: 260px;
    margin-top: 4px;
    color: rgba(3, 10, 38, 0.65);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.web-tab-page {
    .operate-container {
        margin: 16px 0;

        .create-btn {
            display: flex;
            align-items: center;
            justify-content: center;

            svg {
                margin-right: 4px;
            }
        }
    }

    .records-table {
        color: var(--text-color-text-primary, rgba(0, 1, 11, 0.93));
        font-family: PingFang SC;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 142.857% */

        .tpl-name-col {
            display: flex;
            align-items: center;
            justify-content: center;

            .tag {
                margin-left: 4px;
                display: flex;
                padding: 2px 8px;
                justify-content: center;
                align-items: center;
                color: var(--global-color-gray-color-gray-9, #414758);
                font-family: PingFang SC;
                font-size: 12px;
                font-style: normal;
                font-weight: 400;
                line-height: 16px; /* 133.333% */
                border-radius: var(--radius-radius-normal, 3px);
                background: #EEF0F6;
            }
        }

        .theme-color-col {
            width: 20px;
            height: 20px;
        }

        .use-detail-col {
            .detail-label {
                /deep/ .desc {
                    color: var(--text-color-text-secondary, rgba(1, 10, 40, 0.65));
                }
            }

            .show-detail-tip {
                color: var(--text-color-text-secondary, rgba(1, 10, 40, 0.65));
                cursor: pointer;
            }
        }

        .btn {
            color: var(--primary-color-primary-normal, #3E71FF);
            text-align: center;
            /* body/--body-regular */
            font-family: PingFang SC;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 20px; /* 142.857% */
            cursor: pointer;
            margin-left: 16px;

            &:first-child {
                margin-left: 0;
            }

            &.disable {
                cursor: not-allowed;
                opacity: 0.5;
            }
        }
    }

    .records-pagination {
        margin: 12px 16px;
    }
}
</style>
